module.exports = __webpack_public_path__ + "img/rendier.e7f8a032.jpg";